export default  {"src":"/_next/static/image/assets/icons-static/Logo.f343d6b9b4677e52f9a8af1017d977b4.svg","height":36,"width":36};